import * as d3 from 'd3';
import UnitsDayAxis from './UnitsDayAxis.js';
import UnitsWeekAxis from './UnitsWeekAxis.js';
import UnitsMonthAxis from './UnitsMonthAxis.js';
import UnitsQuarterAxis from './UnitsQuarterAxis.js';
import UnitsYearAxis from './UnitsYearAxis.js';

export default class UnitsChart {
  constructor(element, data, options) {
    this.element = element;
    this.options = options;
    this.components = [];
  }

  update() {
    this.components.forEach((component) => component.update());
  }

  rebuild() {
    this.chart.remove();
    this.build();
  }

  buildComponents(components) {
    components.forEach((component, index) => {
      this.components[index] = new component({
        chart: this.chart,
        options: this.options,
      });
      this.components[index].build();
    });
  }

  build() {
    d3.select(this.element).selectAll('svg').remove(); // clearing previous

    const { width } = this.options;
    this.options.height = 42;
    this.chart = d3
      .select(this.element)
      .append('svg')
      .attr('class', 'chart')
      .attr('width', width)
      .attr('height', this.options.height);

    const componentsToInclude = [];

    if (this.options.scaleType === 'week') {
      componentsToInclude.push(UnitsDayAxis);
      componentsToInclude.push(UnitsWeekAxis);
    }

    if (this.options.scaleType === 'month') {
      componentsToInclude.push(UnitsMonthAxis);
      componentsToInclude.push(UnitsWeekAxis);
    }

    if (this.options.scaleType === 'quarter') {
      componentsToInclude.push(UnitsMonthAxis);
      componentsToInclude.push(UnitsQuarterAxis);
    }

    if (this.options.scaleType === 'year') {
      componentsToInclude.push(UnitsQuarterAxis);
      componentsToInclude.push(UnitsYearAxis);
    }

    this.buildComponents(componentsToInclude);
  }
}
